
    import { computed, defineComponent, ref } from 'vue';
    import { useRoute } from 'vue-router';

    function bespokeComposition () {
		/**
		 * Endpoint
		 */
		const route = useRoute();
		const endpointId = computed((): string => {
			return route.params.endpointId as string;
		});

        /**
         * Boxes
         */
        const boxesActive = ref<string[]>([]);
        const boxesLeft = ['derma', 'cardiac', 'endocrine', 'gastro'];
        const boxesRight = ['neuro', 'cardio', 'hepatic', 'renal'];

        function activateBox (box: string): void {
            if (boxesActive.value.includes(box)) {
                const boxIndex = boxesActive.value.indexOf(box);
                boxesActive.value.splice(boxIndex, 1);
            } else {
                boxesActive.value.push(box);
            }
        }

        const boxesActiveClass = computed(() => {
            return `is-${boxesActive.value.join(' is-')}`;
        })

		return { 
            endpointId,
            boxesLeft,
            boxesRight,
            boxesActive,
            activateBox,
            boxesActiveClass
        }
	}

    export default defineComponent({
        setup() {
            return { ...bespokeComposition() }
        },
    })
